
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/usage-statistics",
      function () {
        return require("private-next-pages/resources/usage-statistics.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/usage-statistics"])
      });
    }
  